import { lazy } from 'react';
import { authRoles } from 'src/app/auth';
import ViewApplication from './ViewApplication';

const Applications = lazy(() => import('./Applications'));
const Document = lazy(() => import('./Document'));

const ApplicationsConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  authRoles: authRoles.user,
  routes: [
    {
      path: '/apps/documents/my-applications',
      element: <Applications />,
    },
    {
      path: '/apps/documents/my-applications/view/:id',
      element: <ViewApplication />,
    },
    {
      path: '/apps/documents/my-applications/doc/:id',
      element: <Document />,
    },
  ],
};

export default ApplicationsConfig;
